import {
  Option,
  SelectBox,
  SelectBoxProps,
  styled,
} from "@monolith-forensics/monolith-ui";
import {
  PRESERVATION_TRIGGER_TYPES,
  PreservationTriggerType,
} from "../preservations.constants";

export type PreservationTriggerTypeSelectBoxProps = Omit<
  SelectBoxProps,
  | "data"
  | "renderOption"
  | "OptionTooltip"
  | "searchable"
  | "loading"
  | "defaultValue"
  | "value"
> & {
  defaultValue?: Option;
  value?: Option;
};

// Tooltip content component
const TooltipContent = styled(
  ({
    className,
    data,
  }: {
    className?: string;
    data: PreservationTriggerType;
  }) => {
    return (
      <div className={className}>
        <div className="detail-title">Preservation Trigger Type</div>
        <div className="detail-item">
          <div className="detail-label">Name: </div>
          <div className="detail-value">{data.name || "None"}</div>
        </div>
      </div>
    );
  }
)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: fit-content;
  max-width: 300px;

  .detail-title {
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 8px;
  }

  .detail-item {
    display: flex;
    gap: 2px;
  }

  .detail-label {
    font-weight: bold;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 12px;
  }

  .detail-value {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 12px;
  }
`;

export const PreservationTriggerTypeSelectBox: React.FC<PreservationTriggerTypeSelectBoxProps> =
  (props) => {
    const records: PreservationTriggerType[] = PRESERVATION_TRIGGER_TYPES;

    // Combine number and name in label for client-side search by either
    const options: Option[] = records.map((triggerType) => {
      return {
        label: triggerType.name,
        value: triggerType.id,
        data: triggerType,
      };
    });

    return (
      <SelectBox
        placeholder="Select or search for a preservation trigger type..."
        label="Trigger Type"
        description="The type of trigger that caused the preservation to be created"
        OptionTooltip={TooltipContent}
        openOnFocus={false}
        {...props}
        data={options}
        searchable={true}
      />
    );
  };
